import { Modal, Input } from '@chikara/ui';
import { sanitizeAlphanumeric } from '@chikara/utils';
import { useState, useEffect } from 'react';
import styles from '@/features/card/pages/CardDetailPage/CardDetailPage.module.css';
import { t } from '@/i18n';

interface EditTagModalProps {
    isOpen: boolean;
    onClose: () => void;
    tagName: string;
    onSave: (newName: string) => Promise<void>;
}

export const EditTagModal = ({
    isOpen,
    onClose,
    tagName,
    onSave,
}: EditTagModalProps) => {
    const [name, setName] = useState(tagName);

    useEffect(() => {
        setName(tagName);
    }, [tagName, isOpen]);

    const handleSave = async () => {
        if (name.trim() && name.trim() !== tagName) {
            await onSave(name.trim());
        } else if (name.trim() === tagName) {
            onClose();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            isActionDisabled={!name.trim() || name.trim() === tagName}
            onClose={onClose}
            title={t('dashboard.card.detail.modals.editTag.title')}
            description={
                <div className={styles.editAliasContent}>
                    <p className={styles.editAliasDescription}>
                        {t('dashboard.card.detail.modals.editTag.description')}
                    </p>
                    <Input
                        label={t('dashboard.card.detail.modals.editTag.label')}
                        value={name}
                        onChange={(e) => {
                            setName(sanitizeAlphanumeric(e.target.value));
                        }}
                        size="md"
                        autoFocus
                    />
                </div>
            }
            actionLabel={t('dashboard.card.detail.modals.editTag.save')}
            onAction={handleSave}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            showCloseButton={true}
        />
    );
};
